var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 60,
    viewBox: "0 0 65 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 63.75,
    height: 58.75,
    rx: 5,
    fill: "#161717",
    stroke: "#6E6A6A",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4531 26C18.9125 26 20.9062 27.9937 20.9062 30.4531C20.9062 32.9125 18.9125 34.9062 16.4531 34.9062C13.9937 34.9062 12 32.9125 12 30.4531C12 27.9937 13.9937 26 16.4531 26ZM33.2751 26C35.7345 26 37.7282 27.9937 37.7282 30.4531C37.7282 32.9125 35.7345 34.9062 33.2751 34.9062C30.8157 34.9062 28.822 32.9125 28.822 30.4531C28.822 27.9937 30.8157 26 33.2751 26ZM54.5502 30.4531C54.5502 27.9937 52.5564 26 50.0971 26C47.6377 26 45.644 27.9937 45.644 30.4531C45.644 32.9125 47.6377 34.9062 50.0971 34.9062C52.5564 34.9062 54.5502 32.9125 54.5502 30.4531Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.ef70720a71a6dc236ed14b9fbf904af4.svg";
export { ForwardRef as ReactComponent };